import { Button, ButtonGroup } from '@chakra-ui/react'
import { MeetingThreadsSortMode } from '@rolebase/shared/model/threadWeather'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const meetingThreadsSortModes = [
  MeetingThreadsSortMode.Free,
  MeetingThreadsSortMode.Role,
  MeetingThreadsSortMode.Member,
  MeetingThreadsSortMode.Priority,
]

interface Props {
  value: MeetingThreadsSortMode
  readOnly?: boolean
  onChange: (mode: MeetingThreadsSortMode) => void
}

// The reading order of the tensions step. Shared by everyone in the meeting: a
// meeting is synchronised, and "the third tension" must name the same one for
// all (REU89-D7).
export default function MeetingThreadsSortBar({
  value,
  readOnly,
  onChange,
}: Props) {
  const { t } = useTranslation()

  return (
    <ButtonGroup size="sm" isAttached variant="outline">
      {meetingThreadsSortModes.map((mode) => (
        <Button
          key={mode}
          isActive={mode === value}
          isDisabled={readOnly}
          onClick={() => mode !== value && onChange(mode)}
        >
          {t(`MeetingThreadsSortBar.${mode}`)}
        </Button>
      ))}
    </ButtonGroup>
  )
}
